import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import React, { ReactNode } from 'react'
import { getButtonTestId } from './getButtonTestId'

/** @notExported */
interface AddToArrayButtonProps {
  /** Action to be performed when the button is clicked. */
  clickAction: () => void
  /** Whether the button should be disabled or not. */
  valid?: boolean
  /** Button label. */
  label?: React.ReactNode
  /** Button icon. */
  icon?: React.ReactElement
  /** Tooltip for the button. */
  tooltip?: string | ReactNode
  /** Custom look for the button. */
  customLook?: 'outlined' | 'contained'
  /** Whether to set the button's width to 100%. */
  maxWidth?: boolean
  /** Test id of the button. */
  testId?: string
}

/**
 * Add to array button.
 *
 * @returns Add to array button component.
 * @notExported
 * @category Buttons
 */
const AddToArrayButton: React.FC<AddToArrayButtonProps> = ({
  clickAction,
  valid = true,
  label,
  icon,
  tooltip,
  customLook,
  maxWidth,
  testId,
}) => {
  const labelText = typeof label === 'string' ? label : ''
  const tooltipText = typeof tooltip === 'string' ? tooltip : ''
  const ariaLabel = labelText || tooltipText || 'add item'
  const resolvedTestId = getButtonTestId({ fallback: 'button-add-to-array', label, testId })

  const getButton = () => {
    return (
      <Button
        data-testid={resolvedTestId}
        aria-label={ariaLabel}
        disabled={!valid}
        startIcon={icon}
        variant={customLook ?? 'outlined'}
        color="primary"
        sx={{
          width: maxWidth && !label ? '100%' : label ? '100%' : undefined,
          marginTop: '10px',
          paddingRight: !label ? '3px' : 'inherit',
          marginBottom: '1px',
        }}
        onClick={() => clickAction()}
      >
        {label ?? ''}
      </Button>
    )
  }
  return <>{tooltip ? <Tooltip title={tooltip}>{getButton()}</Tooltip> : getButton()}</>
}

export default AddToArrayButton
